import PropTypes from 'prop-types';
import React, { useEffect } from 'react';

function TabScrollable({
  tabs, isScrolling, setIsScrolling, activeTab, setActiveTab, refs, showButton, setShowButton, setIsSticky,
}) {
  // scrollable tab view
  useEffect(() => {
    const handleScroll = () => {
      if (isScrolling) return;
      const isMobile = window.innerWidth <= 768; // get mobile screen
      const sections = tabs.map((tab) => ({
        id: tab.id,
        ref: refs[tab.id],
      }));
      const scrollPosition = window.scrollY + 218;
      // const windowHeight = window.innerHeight;
      // const documentHeight = document.documentElement.scrollHeight;
      if (isMobile) { // Always show button on mobile
        setShowButton(true);
      } else if (window.scrollY > 250) {
        if (!showButton) setShowButton(true);
      } else if (showButton) {
        setShowButton(false);
      }
      if (window.scrollY > 150) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }

      // normally
      for (let i = sections.length - 1; i >= 0; i -= 1) {
        const section = sections[i];
        if (section.ref.current && section.ref.current.offsetTop <= scrollPosition) {
          setActiveTab(section.id);
          break;
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [isScrolling, tabs, refs, setActiveTab]);
  const scrollToSection = (sectionId) => {
    setIsScrolling(true);
    setActiveTab(sectionId);

    const targetRef = refs[sectionId];
    if (targetRef?.current) {
      // const mainHeader = 56;
      // const tabBar = 100;
      const totalHeaderHeight = 180;
      const isMobile = window.innerWidth <= 768;
      let scrollHt; // use for scrolll height 0
      if (!isMobile) {
        scrollHt = window.scrollY === 0 ? -120 : window.scrollY;
      } else {
        scrollHt = window.scrollY;
      }
      const elementPosition = targetRef.current.getBoundingClientRect().top;
      const offsetPosition = elementPosition + scrollHt - totalHeaderHeight;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth',
      });
      //---------

      if (isMobile || offsetPosition > 200) {
        setShowButton(true);
        setIsSticky(true);
      } else {
        setShowButton(false);
        setIsSticky(false);
      }
    }

    setTimeout(() => setIsScrolling(false), 1000);
  };

  // end---
  return (
    <div>
      <div className="flex space-x-1 lg:px-0 px-4">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            type="button"
            onClick={() => scrollToSection(tab.id)}
            className={`px-4 py-2 text-sm transition-all relative text-nowrap duration-300 ease-out ${
              activeTab === tab.id
                ? 'text-customBlue font-medium'
                : 'text-black font-normal hover:text-gray-900'
            }`}
          >
            {tab.label}
            <span
              className={`absolute bottom-0 left-0 right-0 h-0.5 bg-customBlue transition-all duration-300 ease-out ${
                activeTab === tab.id ? 'opacity-100 scale-x-100' : 'opacity-0 scale-x-0'
              }`}
            />
          </button>
        ))}
      </div>
    </div>
  );
}

TabScrollable.propTypes = {
  tabs: PropTypes.any,
  isScrolling: PropTypes.any,
  setIsScrolling: PropTypes.any,
  activeTab: PropTypes.any,
  setActiveTab: PropTypes.any,
  refs: PropTypes.any,
  showButton: PropTypes.any,
  setShowButton: PropTypes.any,
  setIsSticky: PropTypes.any,
};

export default TabScrollable;
